import { Serializer } from 'survey-core';
import type {
  CheckInCustomizationContext,
  CheckInSurveyPlugin,
  SurveyJsonElement,
  SurveyJsonPayload,
} from '../types';
import {
  WITHINGS_PREFILL_PROPERTY,
  WITHINGS_PREFILL_SOURCE,
  isWeighingReminder,
} from './withingsPrefill.config';

// SurveyJS drops unknown JSON keys unless the property is registered.
if (!Serializer.findProperty('question', WITHINGS_PREFILL_PROPERTY)) {
  Serializer.addProperty('question', {
    name: WITHINGS_PREFILL_PROPERTY,
    type: 'string',
    category: 'general',
  });
}

const withoutWeighingReminder = (
  element: SurveyJsonElement,
): SurveyJsonElement => {
  if (!isWeighingReminder(element.description)) return element;
  const next = { ...element };
  delete next.description;
  return next;
};

const withAnswer = (
  element: SurveyJsonElement,
  answers: Record<string, string>,
): SurveyJsonElement => {
  const name = element.name;
  if (!name) return element;
  const answer = answers[name];
  if (answer == null || answer === '') return element;
  if (element.defaultValue != null && element.defaultValue !== '') {
    return element;
  }
  return withoutWeighingReminder({
    ...element,
    defaultValue: answer,
    [WITHINGS_PREFILL_PROPERTY]: WITHINGS_PREFILL_SOURCE,
  });
};

const augment = (
  payload: SurveyJsonPayload,
  context: CheckInCustomizationContext,
): SurveyJsonPayload => {
  const prefill = context.checkInPrefill;
  if (!prefill || prefill.source !== WITHINGS_PREFILL_SOURCE) return payload;
  const answers = prefill.answers ?? {};

  return {
    ...payload,
    pages: payload.pages?.map((page) => ({
      ...page,
      elements: page.elements?.map((element) => withAnswer(element, answers)),
    })),
  };
};

export const withingsPrefillPlugin: CheckInSurveyPlugin = {
  id: 'withingsPrefill',
  augment,
  pages: {},
};
